import {
    EDIT_USUARIO,
    FETCH_USUARIOS,
    FETCH_TOKEN_RESET_PASSWORD,
    FETCH_USUARIO,
    SET_FILTRO_USUARIOS,
    LOADING_USUARIOS
} from '../actions/types';

const initialState = {
    isLoading: false,
    filtro: {},
    usuarios: [],
    usuario: {},
    user: {},
    token: "",
    error: false
}

export default function (state = initialState, action) {
    switch (action.type) {
        case EDIT_USUARIO:
            if (action.payload.nuevoPassword != action.payload.confirmarPassword) {
                return { ...state, usuario: action.payload, error: true }
            } else {
                return { ...state, usuario: action.payload, error: false }
            }
        case LOADING_USUARIOS:
            return {
                ...state,
                isLoading: action.payload
            };
        case FETCH_USUARIOS:
            return {
                ...state,
                usuarios: action.payload
            };
        case SET_FILTRO_USUARIOS:
            return {
                ...state,
                filtro: action.payload
            };
        case FETCH_TOKEN_RESET_PASSWORD:
            return {
                ...state,
                token: action.payload
            };
        case FETCH_USUARIO:
            return {
                ...state,
                user: action.payload
            }
        default: return state
    }
}